import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  gql,
  useApolloClient,
  useMutation,
} from "@apollo/client";
import { CheckboxProfile } from "../../components/inputs/CheckboxProfile";
import { TextInputWTitleDisable } from "../inputs/TextInputWTitleDisable";
import { InputTitle } from "../inputs/InputTitle";
import { TextInputWTitle } from "../inputs/TextInputWTitle";
import { SelectDateInput } from "../inputs/SelectDateInput";
import { TextBtn } from "../inputs/TextBtn";
import { TextInputWTitleDisableBig } from "../inputs/TextInputWTitleDisableBig";
import { SelectInputWTitle } from "../inputs/SelectInputWTitle";
import { TextInputBig } from "../inputs/TextInputBig";
import { Resume_Query } from "../../pages/Work/WorkPageResume";
import { FileInput } from "../inputs/FileInput";
import { ImageInput } from "../inputs/ImageInput";
import { IconEraser } from "../../assets/IconEraser";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {Checkbox, FormLabel} from "@material-ui/core"

const StyleCss = styled.div`
  grid-column: 1 / 13;
  width: auto !important;
  .loading-ep {
    display: flex;
    justify-content: center;
    margin: 100px auto 0;
  }
  .container {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 40px 40px 40px 20px;
    &.notop {
      padding: 0 40px 0 20px;
    }
    .rightelement,
    .leftelement {
      width: 48%;
      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
    .full-width {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(110px / 12)));
      grid-gap: 10px;
      /* margin: 2rem 0 0; */
      /* padding: 2rem 0 0; */
      border-top: 1px solid var(--n-grey-3);
      &.title {
        border: none;
        margin: 0;
        padding: 0;
        align-items: center;
        display: flex;
        .show {
          align-items: center;
          display: flex;
        }
        .title {
          font-size: 1.3rem;
          font-weight: 600;
        }
      }
      
      &.bbtm {
        border-top: none;
        /* border-bottom: 1px solid var(--n-grey-3); */
      }
    }
    .vertical-devider {
      width: 1px;
      border-left: 1px solid var(--n-grey-3);
    }
    .expand {
      flex-grow: 1;
    }
    .row {
      display: flex;
      margin: 0rem 0;
      padding: 0 0;
      
      :first-child{
        margin: 0 0 0;
      }
      .show {
        align-self: center;
        display: flex;
        align-items: center;
        max-width: 100px;
      }
      .textarea {
        height: 5rem !important;
        width: 50% !important;
      }
      .new-input {
        flex-grow: 1;
        padding: 0;
      }
      .image-file {
        display: flex;
        width: calc(100% - 1rem);
        padding: 0.5rem;
        border-radius: var(--border-radius);
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        .texts {
          width: calc(60% - 1.5rem);
          margin: 0 0.5rem 0 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            margin: 6px 0;
            font-size: 11px;
            font-weight: 500;
          }
          .desc {
            font-size: 11px;
            font-weight: normal;
            text-align: justify;
            color: var(--n-grey-7);
          }
        }
        .image {
          width: 40%;
          padding-top: 40%;
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          img {
            width: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
            background-color: var(--n-grey-3);
          }
        }
      }
      &.data {
        display: flex;
        margin: 0.5rem 0;
        /* border-bottom: 1px solid lightgray; */
        padding: 0.3rem 0;
        grid-column: 1/13;
        :last-child{
          border-bottom: none;
        }
        .right {
          width: 40%;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }
        .left {
          width: 40%;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          .date {
            display: flex;
            align-items: center;
            gap: 1rem;
            .title-date {
              text-align: right;
              width: 50px;
            }
          }
        }
        .expand {
          flex-grow: 1;
        }
        .actions {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 0.5rem;
          align-items: center;
          margin-left: 0.5rem;
          .action {
            padding: 8px;
            border: 1px solid var(--n-grey-3);
            background-color: var(--n-grey-1);
            border-radius: 4px;
            .erase {
              display: block;
              stroke: var(--n-grey-7);
              width: 18px;
              height: 18px;
            }
          }
        }
      }
    }
  }
`;



const EditResume_Mutation = gql`
  mutation EditResume(
    $_id: ID!,
    $Name: String,
    $Position: String,
    $Image: String,
    $Email: String,
    $Mobile: String,
    $Province: String,
    $Address: String,
    $Maried: String,
    $BirthYear: String,
    $Gender: String,
    $Military: String,
    $Job: String,
    $Description: String,
    $DescriptionJob: String,
    $imageNew: Upload,
    $JobBack: [JobBackInput],
    $EduBack: [EduBackInput],
    $LanBack: [LanBackInput],
    $booleans: resumeBooleansInput,
  ) {
    editResume(
      resume: {
        _id: $_id
        Name: $Name
        Position: $Position
        Image: $Image
        Email: $Email
        Mobile: $Mobile
        Province: $Province
        Address: $Address
        Maried: $Maried
        BirthYear: $BirthYear
        Gender: $Gender
        Military: $Military
        Job: $Job
        Description: $Description
        DescriptionJob: $DescriptionJob
        imageNew: $imageNew
        JobBack: $JobBack
        EduBack: $EduBack
        LanBack: $LanBack
        booleans: $booleans
      }
    ) {
      status
    }
  }
`;


function ResumeDataEdit(props) {
  const params = useLocation();
  const returnPath = (new URLSearchParams(params.search)).get("return")
  const history = useHistory();
  const client = useApolloClient()

  const [id, setID] = useState("");
  const [rEdit, setREdit] = useState({});
  const [changed, setChanged] = useState(false);

  const [errors, setErrors] = useState({
    Name: "",
    BirthYear: "",
  });

  useEffect(() => {
    if(props.resume){
      setREdit(props.resume);
      setID(props.resume._id);
    }
    let data = JSON.parse(localStorage.getItem("user-lotus"));
    // set initial if exists
    if (data) {
      setChanged(false);
    }
  }, []);

  const [CDataQuery, { loading }] = useMutation(
    EditResume_Mutation,
    {
      onCompleted: proccessData,
    }
  );

  function proccessData(newData) {
    if (newData.editResume.status) {
      props.updateError({
          text: 'Saved successfully',
          time: 3,
          type: 'confirm'
      });
      client.refetchQueries({include: [Resume_Query]})
      cancel();
    }
  }



  const onchange = (e) => {
    let value = e.target.value;
    let index = parseInt(e.target.index);
    let temp = {...rEdit};
    switch (e.target.name) {
      case "Name":
        temp.Name= value
        break;
      case "Position":
        temp.Position= value
        break;
      case "Address":
        temp.Address= value
        break;
      case "Maried":
        temp.Maried= value
        break;
      case "gender":
        temp.Gender= value
        break;
      case "BirthYear":
        temp.BirthYear= value
        break;
      case "Email":
        temp.Email= value
        break;
      case "Mobile":
        temp.Mobile= value
        break;
      case "Military":
        temp.Military= value
        break;
      case "Email":
        temp.Email= value
        break;
      case "Description":
        temp.Description= value
        break;
      case "DescriptionJob":
        temp.DescriptionJob= value
        break;
      case "JobBack":
        let tempJobBack = [...temp.JobBack];
        tempJobBack[index]= value;
        temp.JobBack = tempJobBack
        break;
      case "EduBack":
        let tempEduBack = [...temp.EduBack];
        tempEduBack[index]= value;
        temp.EduBack = tempEduBack
        break;
      case "LanBack":
        let tempLanBack = [...temp.LanBack];
        tempLanBack[index]= value;
        temp.LanBack = tempLanBack
        break;
      case 'filecard':
        if(e.target.files[0]){
          temp.imageNew = e.target.files[0];
        }
        break;
      default:
        break;
    }
    setREdit(temp)
    setChanged(true);
  };
  const onchangeBoolean = (e) => {
    let [name1, name2] = e.target.name.split("-");
    let temp = {...rEdit};
    let temp2 = {...temp[name1]};
    temp2[name2] = !(temp2[name2]);
    temp[name1] = temp2;
    setREdit(temp)
    setChanged(true);
  }

  function sendData() {
    // console.log('here')
    setChanged(false);
    let tempJobBack = [...rEdit.JobBack].map(v => {
      return {
        JobTitle: v.JobTitle,
        companyName: v.companyName,
        InDate: v.InDate,
        OutDate: v.OutDate,
        Working:v.Working,
      }
    });
    let tempEduBack = [...rEdit.EduBack].map(v => {
      return {
        EduTitle: v.EduTitle,
        Where: v.Where,
        EduName: v.EduName,
        InDate: v.InDate,
        OutDate: v.OutDate,
      }
    });
    let tempLanBack = [...rEdit.LanBack].map(v => {
      return {
        LanTitle: v.LanTitle,
        Level: v.Level,
      }
    });
    let tempBooleans = {...(rEdit["booleans"] ? rEdit["booleans"] : {})}
    delete tempBooleans.__typename;
    CDataQuery({
      variables: {
        ...rEdit,
        _id: id,
        JobBack: tempJobBack,
        EduBack: tempEduBack,
        LanBack: tempLanBack,
        booleans: tempBooleans
      },
    });
  }


  const checkData = () => {
    if (
      changed &&
      id
    ) {
      return true;
    } else {
      return false;
    }
  };
  const cancel = () => {
    if(returnPath){
      history.push(returnPath);
      return; 
    }
    history.push("/work/resume");
  };


  let data2 = props.userdata
  let data = props.resume
  let booleans = (rEdit["booleans"]) ? rEdit["booleans"] : {};
  return (
    <StyleCss>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            Personal Info 
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="rightelement">
          <div className="row">
            <TextInputWTitle
              name={"Name"}
              value={rEdit.Name}
              error={errors.Name}
              onchange={onchange}
              title="Name"
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Position"}
              value={rEdit.Position}
              error={(errors.Position) ? errors.Position : ""}
              onchange={onchange}
              title="Position"
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Email"}
              value={rEdit.Email}
              error={""}
              onchange={onchange}
              title="Email"
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Mobile"}
              value={rEdit.Mobile}
              error={""}
              onchange={onchange}
              title="Mobile"
            />
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Birthday</InputTitle>
              <SelectDateInput value={rEdit.BirthYear} name={'BirthYear'} onchange={onchange} error={''}/>
            </div>
            <div className="show">
              <Checkbox 
                checked={(booleans["BirthYear"]) ? true : false} 
                onChange={onchangeBoolean}
                name="booleans-BirthYear"
              />
              <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
            </div>
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Address"}
              value={rEdit.Address}
              error={""}
              onchange={onchange}
              title="Address"
            />
            <div className="show">
            <Checkbox 
              checked={(booleans["Address"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-Address"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
            </div>
          </div>
        </div>
        <div className='vertical-devider'></div>
        <div className="leftelement">
          <div className="expand"></div>
          <div className="row">
            <ImageInput
              name={"filecard"}
              value={rEdit.image}
              error={""}
              onchange={onchange}
            />
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Gender</InputTitle>
              <CheckboxProfile value={rEdit.Gender} name={'gender'} onchange={onchange}/>
            </div>
          </div>
          <div className="row">
            <SelectInputWTitle 
              title={'Wedded Situation'} 
              name={'Maried'} 
              value={rEdit.Maried}
              options={[
                {
                  value: "no",
                  name: "Not Maried",
                },{
                  value: "yes",
                  name: "Maried",
                },{
                  value: "separated",
                  name: "separated",
                }
              ]} 
              error={''} 
              onchange={onchange}
            />
            <div className="show">
              <Checkbox 
                checked={(booleans["Maried"]) ? true : false} 
                onChange={onchangeBoolean}
                name="booleans-Maried"
              />
              <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
            </div>
          </div>
          {
            (rEdit.Gender === "male") ? (
              <div className="row">
                <SelectInputWTitle 
                  title={'Military Service'} 
                  name={'Military'} 
                  value={rEdit.Military}
                  options={[
                    {
                      value: "no",
                      name: "Not served",
                    },{
                      value: "yes",
                      name: "Served",
                    },{
                      value: "Exemption",
                      name: "Exemption",
                    }
                  ]} 
                  error={''} 
                  onchange={onchange}
                />
                <div className="show">
                  <Checkbox 
                    checked={(booleans["Military"]) ? true : false} 
                    onChange={onchangeBoolean}
                    name="booleans-Military"
                  />
                  <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
                </div>
              </div>
            ) : ""
          }
          
          
        </div>
      </div>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            About Me
          </div>
          <div className="show">
            <Checkbox 
              checked={(booleans["Description"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-Description"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="full-width bbtm">
          <div className="row" style={{ gridColumn: "1 / 13" }}>
            <TextInputBig
              name={"Description"}
              value={(rEdit.Description) ? rEdit.Description : "پرکنید"}
              title={''}
              error={""}
              onchange={onchange}
            />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            Professional Skills
          </div>
          <div className="show">
            <Checkbox 
              checked={(booleans["DescriptionJob"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-DescriptionJob"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="full-width bbtm">
          <div className="row" style={{ gridColumn: "1 / 13" }}>
            <TextInputBig
              name={"DescriptionJob"}
              value={(rEdit.DescriptionJob) ? rEdit.DescriptionJob : "پرکنید"}
              title={''}
              error={""}
              onchange={onchange}
            />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            Job Experience
          </div>
          <div className="show">
            <Checkbox 
              checked={(booleans["JobBack"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-JobBack"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="full-width bbtm">
          { (rEdit.JobBack) ?
            rEdit.JobBack.map((val, i) => {
              return (
                <Jobs 
                  key={i}
                  index={i}
                  data={val} 
                  name={"JobBack"} 
                  onchange={onchange}
                  delete={() => {
                    let temp = {...rEdit};
                    let tempJobBack = [...temp.JobBack];
                    tempJobBack.splice(i, 1);
                    temp.JobBack = tempJobBack
                    setREdit(temp);
                    setChanged(true);
                  }}
                />)
            }) : ""
          }
          <TextBtn
            onclick={() => {
              let temp = {...rEdit};
              let tempJobBack = [...temp.JobBack];
              tempJobBack.push({
                JobTitle: "",
                companyName: "",
                InDate: "1400/1/1",
                OutDate: "1400/1/1",
                Working: "",
              })
              temp.JobBack = tempJobBack
              setREdit(temp);
            }}
            text={"Add"}
            type={""}
            newType1={true}
          />
        </div>
      </div>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            Education Background
          </div>
          <div className="show">
            <Checkbox 
              checked={(booleans["EduBack"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-EduBack"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="full-width bbtm">
          { (rEdit.EduBack) ?
            rEdit.EduBack.map((val, i) => {
              return (
                <Education 
                  key={i}
                  index={i}
                  data={val} 
                  name={"EduBack"} 
                  onchange={onchange}
                  delete={() => {
                    let temp = {...rEdit};
                    let tempEduBack = [...temp.EduBack];
                    tempEduBack.splice(i, 1);
                    temp.EduBack = tempEduBack
                    setREdit(temp);
                    setChanged(true);
                  }}
                />
              )
            }) : ""
          }
          <TextBtn
            onclick={() => {
              let temp = {...rEdit};
              let tempEduBack = [...temp.EduBack];
              tempEduBack.push({
                EduTitle: "",
                Where: "",
                EduName: "",
                InDate: "1400/1/1",
                OutDate: "1400/1/1",
              })
              temp.EduBack = tempEduBack
              setREdit(temp);
            }}
            text={"Add"}
            type={""}
            newType1={true}
          />
        </div>
      </div>
      <div className="container">
        <div className="full-width title">
          <div className="title">
            Languages
          </div>
          <div className="show">
            <Checkbox 
              checked={(booleans["LanBack"]) ? true : false} 
              onChange={onchangeBoolean}
              name="booleans-LanBack"
            />
            <FormLabel style={{display: "flex", alignItems: "center"}}>show in profile</FormLabel>
          </div>
        </div>
      </div>
      <div className="container notop">
        <div className="full-width bbtm">
          { (rEdit.LanBack) ?
            rEdit.LanBack.map((val, i) => {
              return (
                <Language 
                  key={i}
                  index={i}
                  data={val} 
                  name={"LanBack"} 
                  onchange={onchange}
                  delete={() => {
                    let temp = {...rEdit};
                    let tempLanBack = [...temp.LanBack];
                    tempLanBack.splice(i, 1);
                    temp.LanBack = tempLanBack
                    setREdit(temp);
                    setChanged(true);
                  }}
                />
              )
            }) : ""
          }
          <TextBtn
            onclick={() => {
              let temp = {...rEdit};
              let tempLanBack = [...temp.LanBack];
              tempLanBack.push({
                LanTitle: "",
                Level: "beginner",
              })
              temp.LanBack = tempLanBack
              setREdit(temp);
            }}
            text={"Add"}
            type={""}
            newType1={true}
          />
        </div>
      </div>
      <div className="container">
        <div className='full-width' style={{paddingTop: "1rem"}}>
          <div style={{ gridColumn: "7 / 9" }}>
            <TextBtn
              onclick={cancel}
              text={"Cancel"}
              type={""}
              newType1={true}
            />
          </div>
          <div style={{ gridColumn: "9 / 13" }}>
            <TextBtn
                text={"Save changes"}
                type={"submit"}
                onclick={sendData}
                loading={loading}
                disabled={!checkData() || loading}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  );
}
export default ResumeDataEdit;




function Jobs (props) {
  const changed = (e) => {
    let value = e.target.value;
    let temp = {...props.data};
    switch(e.target.name){
      case "JobTitle":
        temp.JobTitle= value
        break;
      case "companyName":
        temp.companyName= value
        break;
      case "InDate":
        temp.InDate= value
        break;
      case "OutDate":
        temp.OutDate= value
        break;
      default:
        break;
    }
    if(typeof props.onchange === "function"){
      let event = {
        target: {
          name: props.name,
          value: temp,
          index: props.index,
        }
      }
      // console.log(event);
      props.onchange(event)
    }
  }
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top">
          <TextInputWTitle
            name={"JobTitle"}
            value={data.JobTitle}
            error={""}
            onchange={changed}
            title="Job title"
          />
        </div>
        <div className="small">
          <TextInputWTitle
            name={"companyName"}
            value={data.companyName}
            error={""}
            onchange={changed}
            title="Company name"
          />
        </div>
      </div>
      <div className="expand"></div>
      <div className="left">
        <div className="date">
          <div className="title-date">from:</div> <SelectDateInput value={data.InDate} name={'InDate'} onchange={changed} error={''}/>
        </div>
        <div className="date">
          <div className="title-date">to:</div> <SelectDateInput value={data.OutDate} name={'OutDate'} onchange={changed} error={''}/>
        </div>
      </div>
      <div className="actions">
        <div 
          className="action" 
          onClick={() => props.delete()}
        >
          <IconEraser className={"erase"}/>
        </div>
      </div>
    </div>
  )
}

function Education (props) {
  const changed = (e) => {
    let value = e.target.value;
    let temp = {...props.data};
    switch(e.target.name){
      case "EduName":
        temp.EduName= value
        break;
      case "EduTitle":
        temp.EduTitle= value
        break;
      case "Where":
        temp.Where= value
        break;
      case "InDate":
        temp.InDate= value
        break;
      case "OutDate":
        temp.OutDate= value
        break;
      default:
        break;
    }
    if(typeof props.onchange === "function"){
      let event = {
        target: {
          name: props.name,
          value: temp,
          index: props.index,
        }
      }
      // console.log(event);
      props.onchange(event)
    }
  }
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top" style={{display: "flex", gap: "0.5rem"}}>
          <TextInputWTitle
            name={"EduName"}
            value={data.EduName}
            error={""}
            onchange={changed}
            title="Name of Education"
          />
          <TextInputWTitle
            name={"EduTitle"}
            value={data.EduTitle}
            error={""}
            onchange={changed}
            title="Title of Education"
          />
        </div>
        <div className="small">
          <TextInputWTitle
            name={"Where"}
            value={data.Where}
            error={""}
            onchange={changed}
            title="Location of Education"
          />
        </div>
      </div>
      <div className="expand"></div>
      <div className="left">
        <div className="date">
          <div className="title-date">from:</div> <SelectDateInput value={data.InDate} name={'InDate'} onchange={changed} error={''}/>
        </div>
        <div className="date">
          <div className="title-date">to:</div> <SelectDateInput value={data.OutDate} name={'OutDate'} onchange={changed} error={''}/>
        </div>
      </div>
      <div className="actions">
        <div 
          className="action" 
          onClick={() => props.delete()}
        >
          <IconEraser className={"erase"}/>
        </div>
      </div>
    </div>
  )
}
function Language (props) {
  const changed = (e) => {
    let value = e.target.value;
    let temp = {...props.data};
    switch(e.target.name){
      case "LanTitle":
        temp.LanTitle= value
        break;
      case "Level":
        temp.Level= value
        break;
      default:
        break;
    }
    if(typeof props.onchange === "function"){
      let event = {
        target: {
          name: props.name,
          value: temp,
          index: props.index,
        }
      }
      // console.log(event);
      props.onchange(event)
    }
  }
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <TextInputWTitle
          name={"LanTitle"}
          value={data.LanTitle}
          error={""}
          onchange={changed}
          title="Name of Language"
        />
      </div>
      <div className="expand"></div>
      <div className="left">
        <SelectInputWTitle 
          title={'Level'} 
          name={'Level'} 
          value={data.Level}
          options={[
            {
              value: "beginner",
              name: "Beginner",
            },{
              value: "medium",
              name: "Medium",
            },{
              value: "expert",
              name: "Expert",
            }
          ]} 
          error={''} 
          onchange={changed}
        />
      </div>
      <div className="actions">
        <div 
          className="action" 
          onClick={() => props.delete()}
        >
          <IconEraser className={"erase"}/>
        </div>
      </div>
    </div>
  )
}



function FormatDate(props) {
  let inDate = props.InDate.split("/");
  let outDate = props.OutDate.split("/");
  inDate.reverse()
  outDate.reverse()
  inDate = inDate.join('/')
  outDate = outDate.join('/')
  return (
    <>
      from {inDate} to {outDate}
    </>
  )
}